import { useContext } from "react";

import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";
import Search from "./Search";

const StartScreenContent = () => {
    const { screenSize } = useViewport();
    const { state } = useContext(appContext);

    if (!state.isStartScreenVisible) return null;

    let animClass = "";
    if (screenSize === "mobile" && state.isSearchFocusedOnce === true) {
        animClass = " animateFade";
    }

    return (
        <div>
                 <span className={"introText" + animClass}>
                     <p className="introText_large">Get socioeconomic profiles.</p>
                     <p className="introText_small" style={{ paddingBottom: "20px" }}>
                         Download reports for counties near National Forests.
                     </p>
                 </span>
            <Search />
        </div>
    );
};
export default StartScreenContent;


